import { CircularProgress, InputAdornment } from '@mui/material'
import { Controller, ControllerRenderProps } from 'react-hook-form'

import {
  UFormControlInput,
  UIcon,
  UInput,
  UStack,
  UText,
} from '@src/components'

import { SigninEmailMfaValidateObject, useSigninEmailMfaForm } from './_hooks'

type Props = {
  email: string
  isSubmitting: boolean
  onSubmit: (code: string) => void
}

export function SigninEmailMfa({ email, isSubmitting, onSubmit }: Props) {
  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useSigninEmailMfaForm()

  function changeCodeField(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: ControllerRenderProps<SigninEmailMfaValidateObject, 'code'>
  ) {
    const sanitized = event.target.value.replace(/[^0-9]/g, '').slice(0, 6)
    field.onChange(sanitized)
    if (sanitized.length === 6) {
      handleSubmit((data: SigninEmailMfaValidateObject) =>
        onSubmit(data.code)
      )()
    }
  }

  return (
    <>
      <UInput
        fullWidth
        placeholder="メールアドレス"
        value={email}
        inputProps={{ readOnly: true }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <UIcon name="email" color="grayDark" />
            </InputAdornment>
          ),
        }}
      />
      <UText className="mt-3">
        メールアドレスに認証コードを送信しました。届いた6桁のコードを入力してください。
      </UText>
      <div className="mt-3">
        <Controller
          name="code"
          control={control}
          render={({ field }) => (
            <UFormControlInput
              label="認証コード"
              fullWidth
              error={!!errors.code}
              htmlFor="code"
              required
              uInputProps={{
                ...field,
                helperText: errors.code?.message,
                placeholder: '認証コードを入力',
                inputProps: {
                  autoComplete: 'off',
                  autoFocus: true,
                  disabled: isSubmitting,
                  inputMode: 'numeric',
                  type: 'tel',
                },
                InputProps: {
                  startAdornment: (
                    <UIcon
                      name="pin"
                      className="mr-1"
                      color={errors.code?.message ? 'error' : 'primary'}
                    />
                  ),
                },
                onChange: (event) => changeCodeField(event, field),
              }}
            />
          )}
        />
        {isSubmitting && (
          <UStack alignItems="center" className="mt-2" spacing={2}>
            <CircularProgress />
            <UText>認証中...</UText>
          </UStack>
        )}
      </div>
    </>
  )
}
